import messages from './messages-de.json';

export default function() {
  return {
    locale: 'de',
    messages
  };
}
